"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBanners = void 0;
const tslib_1 = require("tslib");
const axios_1 = tslib_1.__importDefault(require("axios"));
const createUrl_1 = require("../../utils/createUrl");
const urlMapping = {
    banners: {
        client: 'search/v2/banners/{organisationId}',
    },
};
const getBanners = (_a, _b) => tslib_1.__awaiter(void 0, [_a, _b], void 0, function* ({ url, organisationId }, { placement }) {
    const requestUrl = (0, createUrl_1.createUrl)(url, urlMapping.banners, false, {
        organisationId,
    });
    const axiosConfig = {
        method: 'POST',
        url: requestUrl,
        data: {
            location: 'Homepage', // Required
            filters: [
                {
                    field: 'placement',
                    operator: 'EQUAL',
                    value: placement,
                },
            ],
        },
    };
    const result = yield axios_1.default.request(axiosConfig);
    return result.data;
});
exports.getBanners = getBanners;
//# sourceMappingURL=zitcha.api.js.map